import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpRequest from "services/httpRequest";
import snakecaseKeys from "snakecase-keys";

const _urlPrefix = "/appraisal";

export const getPageAppraisal = createAsyncThunk(
  "appraisal/getPageAppraisal",
  async (params) => {
    console.log(' >>> getPageAppraisal');
    const result = await httpRequest({
      url: `${_urlPrefix}/page`,
      method: "GET",
      params: snakecaseKeys(params),
    });
    if (!result) return;
    return result.data;
  }
);

export const createAppraisal = createAsyncThunk(
  "appraisal/createAppraisal",
  async (data) => {
    const result = await httpRequest({
      url: `${_urlPrefix}`,
      method: "POST",
      data: snakecaseKeys(data),
      successMessage: "toast.add.200"
    });
    if (!result) return;
    return result.data;
  }
);

const appraisalSlice = createSlice({
  name: "appraisal",
  initialState: {},
  reducers: {},
});

const { reducer } = appraisalSlice;
// export const {} = actions;
export default reducer;
